export function getNoOfSetsText(noOfSets: number) {
  if (noOfSets === 1) return "1 komplet";

  if (noOfSets > 4) return noOfSets + " kompletów";
  if (noOfSets > 1) return noOfSets + " komplety";
}
